import React from "react";
import "./Slider.sass";
import { useState } from "react";
import imgAltona from "../../assets/img/img-gallery-altona.jpg";
import imgCouch from "../../assets/img/img-gallery-couch.jpg";
import imgDinner from "../../assets/img/img-gallery-dinner.jpg";
import imgDom from "../../assets/img/img-gallery-dom.jpg";
import imgGroningen from "../../assets/img/img-gallery-groningen.jpg";
import imgPhotobooth from "../../assets/img/img-gallery-photobooth.jpg";
import imgPizza from "../../assets/img/img-gallery-pizza.jpg";
import imgTennis from "../../assets/img/img-gallery-tennis.jpg";


function Slider() {
    const images = [
        {
            url: imgDom,
            alt: "Person vor dem Dom",
            description: "Aufm Dom ein Knobibrot holen",
        },
        {
            url: imgAltona,
            alt: "Person vor einem Café",
            description: "In Altona unterwegs",
        },
        {
            url: imgDinner,
            alt: "Personen beim Essen",
            description: "Erntedank-Dinner bei mir zu Hause",
        },
        {
            url: imgCouch,
            alt: "Person auf einer Couch",
            description: "Auf der Couch mit Calcifer",
        },
        {
            url: imgGroningen,
            alt: "Personen in Groningen",
            description: "Urlaub in Groningen",
        },
        {
            url: imgPhotobooth,
            alt: "Personen in einer Fotobox",
            description: "Spaß mit Photobooth Filtern",
        },
        {
            url: imgPizza,
            alt: "Personen beim Essen",
            description: "Jahrestag mit meiner Freundin",
        },
        {
            url: imgTennis,
            alt: "Personen beim Tennis",
            description: "vLnR: Roger Federer",
        },
    ];

    const [current, setCurrent] = useState(0);
    const length = images.length;

    const nextSlide = () => {
        setCurrent(current === length - 1 ? 0 : current + 1);
    };

    const prevSlide = () => {
        setCurrent(current === 0 ? length - 1 : current - 1);
    };

    if (!Array.isArray(images) || images.length <= 0) {
        return null;
    }

    return (
        <section className="slider">
            <div className="slider__prev-slide" onClick={prevSlide}></div>
            <div className="slider__next-slide" onClick={nextSlide}></div>
            <div className="slider__container">
                <div className="slider__slide slider__slide--active">
                    <img className="slider__image" src={images[current].url} alt={images[current].alt} />
                    <p className="slider__desc">{images[current].description}</p>
                    <div className="slider__indicator">
                        {images.map((image, index) => {
                            return (
                                <div className={index === current ? "slider__indicator--active" : "slider__indicator--inactive"} key={index}></div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Slider;
